import React, {  useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import CityForm from './CityForm';
import { CITY_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import {clearCity, getCity, putCity } from '../../../../actions';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import Content from '../../../layout/Content';

const EditCity = ({
  breadcrumbs,
  city,
  match: {
    params: { id },
  },
  loading,
  dispatchClearCity,
  dispatchPutCity,
  dispatchGetCity
})=>{

  useLayoutEffect(() => {
    dispatchGetCity({id})
    return () => dispatchClearCity();
  }, []);

  const onSubmit = (formValues) => {
    const { name, selectedRegion } = formValues;
    const newFormValues = {
      regionId: selectedRegion.value,
      name,
    };
    dispatchPutCity(id, newFormValues);
  }

  let content;

  if (loading) {
    content = <Loader />;
  } else if (city.isEmpty()) {
    content = <NoDataResource returnPage={CITY_PATH} />;
  } else {
    const initialValues = {
      selectedRegion: {
        label: city.get('region').name,
        value: city.get('region').id,
      },
      name: city.get('name'),
    };

    content = (
      <CityForm onSubmit={onSubmit} initialValues={initialValues} />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Ciudad"
      subtitle="Editar Ciudad"
      content={content}
    />
  );
}


EditCity.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetCity: PropTypes.func.isRequired,
  dispatchClearCity: PropTypes.func.isRequired,
  dispatchPutCity: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  city: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditCity.defaultProps = {
  loading: false,
};

const mapStateToProps = (
  { LocationUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...LocationUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Ciudades',
      href: CITY_PATH,
    },
    {
      text: 'Ver',
      href: `${CITY_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  city: LocationUnit.City.getIn(['current', 'content']),
  loading: !LocationUnit.City.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetCity: getCity,
  dispatchClearCity: clearCity,
  dispatchPutCity: putCity,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditCity);
